<!--
 * @Author: wsx
 * @Date: 2022-02-28 10:52:48
 * @LastEditTime: 2022-02-28 17:19:44
 * @Description: 楼层
 * @FilePath: \hz-digital-twin\src\layout\components\MyFloor\index.vue
-->
<template>
  <div class="MyFloor" v-drag>
    <div class="floor-content">
      <ul class="floor-list">
        <template v-for="i in floor" :key="i.id">
          <li
            class="floor-list-item"
            :class="{ current: currentFloor.id === i.id }"
            @click.self="clickFloor(i)"
          >
            {{ i.name }}
          </li>
        </template>
      </ul>
      <ul class="floor-details">
        <template v-for="i in areaList" :key="i.id">
          <li
            class="floor-detail-item"
            :class="{ current: currentArea.id === i.id }"
            @click="selectArea(i)"
          >
            <h-icon icon="icon-019suodingweizhi"></h-icon>
            <span class="floor-detail-name">{{ i.name }}</span>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
export default defineComponent({
  name: "MyFloor",
  setup(props) {
    const state = reactive({
      floor: [
        {
          id: 1,
          name: "1F",
          children: [
            { id: 11, name: "洽谈区" },
            { id: 12, name: "休闲区" },
            { id: 13, name: "机房" },
            { id: 14, name: "会议室" },
            { id: 15, name: "办公室" },
            { id: 16, name: "电梯" },
            { id: 17, name: "卫生间" }
          ]
        },
        {
          id: 2,
          name: "2F",
          children: [
            { id: 21, name: "会议室" },
            { id: 26, name: "电梯" },
            { id: 27, name: "卫生间" }
          ]
        }
      ],
      areaList: [],
      currentFloor: {},
      currentArea: {}
    });
    const refData = toRefs(state);
    // 选择楼层
    const clickFloor = item => {
      state.currentFloor = item;
      state.areaList = item.children || [];
    };
    clickFloor(state.floor[0]);
    // 选择区域
    const selectArea = item => {
      state.currentArea = item;
    };
    return { ...refData, clickFloor, selectArea };
  }
});
</script>
<style lang="scss" scoped>
@import "@/assets/utils.scss";
.MyFloor {
  position: fixed;
  top: 188px;
  left: 580px;
  color: #fff;
  user-select: none;
  z-index: 999;
  .floor-content {
    @include flex-row;
    border-radius: 10px;
    overflow: hidden;
    .floor-list {
      background-color: rgba($color: #000000, $alpha: 0.8);
      padding: 10px 0;
      width: 50px;
      min-height: 200px;
      .floor-list-item {
        width: 100%;
        height: 36px;
        text-align: center;
        line-height: 36px;
        position: relative;
        cursor: pointer;
        &.current {
          box-shadow: 0 0 20px 0 #ffc20a inset;
          &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 3px;
            background-color: #ffc20a;
          }
        }
      }
    }
    .floor-details {
      background-color: rgba($color: #000000, $alpha: 0.5);
      padding: 10px 0;
      min-width: 80px;
      .floor-detail-item {
        padding: 0 20px 0 15px;
        height: 36px;
        cursor: pointer;
        @include flex-row-s-c;
        &.current,
        &:hover {
          box-shadow: 0 0 20px 0 #ffc20a inset;
        }
        .floor-detail-name {
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
